import React from "react";
import get from "lodash/get";
import { CustomLink } from "../../custom-link";
import { SvgHandler } from "../../svg-handler/svg-handler";
import googlePlayIcon from "../../../../assets/icons/download-links/googleplay.svg";
import appStoreIcon from "../../../../assets/icons/download-links/appstore.svg";

export const MobileDownloadLinks = props => {
  const appStoreDownloadLink = get(props, ["appStoreDownloadLink"], "");
  const googlePlayDownloadLink = get(props, ["googlePlayDownloadLink"], "");
  return (
    <>
      {appStoreDownloadLink && (
        <CustomLink href={appStoreDownloadLink} target="_blank">
          <SvgHandler
            xlinkHref={appStoreIcon}
            width="120"
            height="40"
            viewBox="0 0 120 40"
            clazzName="app-store-icon"
          />
        </CustomLink>
      )}
      {googlePlayDownloadLink && (
        <CustomLink href={googlePlayDownloadLink} target="_blank">
          <SvgHandler
            xlinkHref={googlePlayIcon}
            width="135"
            height="40"
            viewBox="0 0 135 40"
            clazzName="google-play-icon"
          />
        </CustomLink>
      )}
    </>
  );
};
